import http from './api';

const getSmsInformation = () => http.get(`api/sms`);
const provisionSms = () => http.post('api/sms/enable');
const addSmsNumber = phoneNumber => http.post('api/sms/addNumber', phoneNumber);
const deleteNumber = phoneNumber => http.post('api/sms/deleteNumber', phoneNumber);

export default {
  getSmsInformation,
  provisionSms,
  addSmsNumber,
  deleteNumber
};
